import React from 'react';
import { Box, Paper, Stack, Typography, Grid, Avatar } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import palette from 'src/theme/palette';

const FactsFeaturesTab = ({ form, featuresOptions, toggleFeature, loadingProperty }) => {
  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Specifications *
      </Typography>

      <Paper variant="outlined" sx={{ p: 2 }}>
        <Stack spacing={3}>
          {featuresOptions.map((category, categoryIndex) => (
            <Box key={category?.category_name || categoryIndex}>
              <Typography
                variant="h6"
                sx={{
                  mb: 2,
                  fontFamily: 'poppinsSemiBold',
                  fontSize: '16px'
                }}
              >
                {category?.category_name}
              </Typography>

              {category?.sub_categories?.map((subCategory, subCatIndex) => (
                <Box key={subCategory?.sub_category_name || subCatIndex} sx={{ mb: 3 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      mb: 1,
                      fontFamily: 'poppinsMedium',
                      fontSize: '14px',
                      color: 'text.secondary'
                    }}
                  >
                    {subCategory?.sub_category_name}
                  </Typography>

                  <Grid container spacing={2}>
                    {subCategory?.features?.map((feature, featureIndex) => (
                      <Grid item xs={12} sm={4} md={3} key={feature?.id || featureIndex}>
                        <Paper
                          onClick={() => !loadingProperty && toggleFeature(feature?.name)}
                          variant="outlined"
                          sx={{
                            p: 1,
                            display: 'flex',
                            alignItems: 'center',
                            cursor: loadingProperty ? 'default' : 'pointer',
                            borderColor: form.features[feature?.name]
                              ? palette.primary.main
                              : undefined,
                            bgcolor: form.features[feature?.name]
                              ? palette.primary.lighter
                              : 'transparent',
                            opacity: loadingProperty ? 0.6 : 1
                          }}
                        >
                          <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            sx={{ width: '100%' }}
                          >
                            <Avatar
                              sx={{
                                bgcolor: 'transparent',
                                color: palette.primary.main,
                                border: `1px solid ${palette.primary.inputborder}`
                              }}
                            >
                              <CheckCircleOutline />
                            </Avatar>
                            <Typography variant="body2" sx={{ fontSize: 14 }}>
                              {feature?.name}
                            </Typography>
                            <Box sx={{ flex: 1 }} />
                          </Stack>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              ))}
            </Box>
          ))}
        </Stack>
      </Paper>
    </Box>
  );
};

export default FactsFeaturesTab;
